<p>fiche-sortie works!</p>
